/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-09 17:04:18
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-10 10:56:35
 */
import http from "@/axios/index";

/**
 * @brief: 养成（育苗）年份/月份/日期分页
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:07:43
 */
export function searchOutSeedlingDailyGroupList(params) {
  const url = '/outSeedlingDailyGroup/searchOutSeedlingDailyGroupList';
  return http.post(url, params);
}
/**
 * 养殖投苗、卵情况报表-（养成、育苗）分页导出
 */
export function exportOutSeedlingDailyGroupList() {
  return '/outSeedlingDailyGroup/exportOutSeedlingDailyGroupList';
}
/**
 * @brief: 区域条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:15:23
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getGroupConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = '/outSeedlingDailyGroup/getGroupConditions';
  return http.post(url, params);
}
/**
 * @brief: 品类条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:16:21
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getTypeConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = '/outSeedlingDailyGroup/getTypeConditions';
  return http.post(url, params);
}
/**
 * @brief: 造次条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:17:05
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getPeriodConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = '/outSeedlingDailyGroup/getPeriodConditions';
  return http.post(url, params);
}
/**
 * @brief: 品种条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:17:05
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getBreedConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = '/outSeedlingDailyGroup/getBreedConditions';
  return http.post(url, params);
}


///////////////////////////////// 排塘记录 //////////////////////////////////
/**
 * @brief: 排塘情况报表-养成、育苗分页
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:12:03
 * @param {*} params
 */
export function searchMdtLossGroupList(params) {
  const url = '/mdtLossGroup/searchMdtLossGroupList';
  return http.post(url, params);
}
/**
 * 排塘况报表-（养成、育苗）分页导出
 */
export function exportOutPondGroupList() {
  return '/mdtLossGroup/exportMdtLossGroupList';
}
/**
 * @brief: 区域（仓库）条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:15:23
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getWarehouseConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = '/mdtLossGroup/getGroupConditions';
  return http.post(url, params);
}
/**
 * @brief: 品类条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:16:21
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getCategoryConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = '/mdtLossGroup/getTypeConditions';
  return http.post(url, params);
}
/**
 * @brief: 批次条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:17:05
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getBatchConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = '/mdtLossGroup/getperiodConditions';
  return http.post(url, params);
}
/**
 * @brief: 造次条件
 * @author: Scarlett Xiao
 * @Date: 2022-03-09 17:17:05
 * @param {*} orgId 机构id
 * @param {*} breedTypeClass fish-养成，egg-育苗
 */
export function getSeasonPeriodConditions(orgId, breedTypeClass) {
  const params = {
    orgId: orgId,
    breedTypeClass: breedTypeClass
  };
  const url = '/mdtLossGroup/getPeriodConditions';
  return http.post(url, params);
}